import React from "react";

import PageRenderer from "@/features/react-editor/components/PageRenderer";
import twMerge from "@replo/design-system/utils/twMerge";
import { ImageOff } from "lucide-react";

interface PreviewThumbnailProps {
  pageRoute: string;
  className?: string;
  fallbackMessage?: string;
}

function PreviewThumbnail({
  pageRoute,
  className,
  fallbackMessage = "No preview",
}: PreviewThumbnailProps) {
  // If no page path, show fallback
  if (!pageRoute) {
    return (
      <div
        className={twMerge(
          "flex h-full w-full flex-col items-center justify-center bg-surface",
          className,
        )}
      >
        <ImageOff size={20} className="text-muted mb-1" />
        <p className="text-muted text-center text-xs">{fallbackMessage}</p>
      </div>
    );
  }

  return (
    <div
      className={twMerge(
        "relative h-full w-full overflow-hidden rounded",
        className,
      )}
    >
      {/* Live preview using ReactRender - it handles its own loading states */}
      <PageRenderer
        pageRoute={pageRoute}
        className="pointer-events-none h-full w-full"
        previewThumbnail
        isScrollable={false}
      />

      {/* Overlay to prevent interaction */}
      <div className="absolute inset-0 bg-transparent pointer-events-none" />
    </div>
  );
}

export default PreviewThumbnail;
